import React from 'react';
import { cx } from '../cx';

// D-09 §15.22 — 단계 인디케이터(.steps-wrap > .steps > .stp[.done/.cur] > .dot/.txt>.lbl+.sub, .bar[.on] 화살표).
// 바깥 .steps-wrap 이 상하 여백(spacing-09)과 중앙 정렬을 담당한다 — 화면마다 래퍼를 다시 짜지 않는다.
// v2.035에서 §15.38 StepsDetail(라벨+서브라벨 2줄)을 이 컴포넌트로 흡수했다. sub 는 항목별 옵셔널이라
// 1줄 항목과 2줄 항목을 한 인디케이터 안에 섞어 쓸 수 있다.

/** 문자열이면 sub 없는 1줄 단계. 객체면 라벨 + 보조 설명(예: "사진 선택" · "3장 완료") 2줄. */
export type StepItem = string | { label: string; sub?: string };

export interface StepsProps extends React.HTMLAttributes<HTMLDivElement> {
  steps: StepItem[];
  current: number; // 현재 단계 index (0-based). current 이전은 done.
}

export function Steps({ steps, current, className = '', ...props }: StepsProps) {
  const items = steps.map(s => (typeof s === 'string' ? { label: s } : s));
  return (
    <div className="steps-wrap">
      <div className={cx('steps', className)} {...props}>
        {items.map((st, i) => {
          const state = i < current ? 'done' : i === current ? 'cur' : '';
          return (
            <React.Fragment key={i}>
              {i > 0 && <div className={cx('bar', i <= current && 'on')} />}
              <div className={cx('stp', state)} aria-current={i === current ? 'step' : undefined}>
                <span className="dot">{i < current ? '✓' : i + 1}</span>
                <span className="txt">
                  <span className="lbl">{st.label}</span>
                  {st.sub && <span className="sub">{st.sub}</span>}
                </span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

/** @deprecated §15.38은 §15.22 `Steps`로 흡수됐다(v2.035). 신규 코드는 `Steps`를 쓴다. */
export const StepsDetail = Steps;
/** @deprecated → `StepItem` */
export type StepsDetailItem = Extract<StepItem, object>;
/** @deprecated → `StepsProps` */
export type StepsDetailProps = StepsProps;
